import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AvatarBlockModule } from '../../shared/avatar-block/avatar-block.module';

@Component({
    selector: 'app-launchpad-demo-mode-deactivated-dialog',
    templateUrl: './launchpad-demo-mode-deactivated-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        AvatarBlockModule,
    ],
})
export class LaunchpadDemoModeDeactivatedDialogComponent
{
}
